import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  BookingComponent, ReceiptComponent, ClientComponent, AllotmentComponent, BookingCancelledListComponent,
  BookingPendingCancellationComponent,
  ReceiptRefundComponent
} from './';
import { PaymentPlanComponent } from './payment-plan/payment-plan.component';
import { AuthGuard } from '../../auth/auth.guard';
import { UnitCategorySaleReportComponent } from './Reports/unit-category-sale-reports/unit-category-sale-report.component';
import { AgentWiseSaleReportComponent } from './Reports/agent-wise-sale-report/agent-wise-sale-report.component';
import { AgeingBucketSaleComponent } from './Reports/aging-bucket-sale/aging-bucket-sale.component';
import { SalesDashboardComponent } from '../dashboard/sales-dashboard/sales-dashboard.component';
import { MarketOutstandingAgeingComponent } from './Reports/market-outstanding-aging/market-outstanding-aging.component';
import { ClientMarketOutstandingAgeingComponent } from './Reports/client-market-outstanding-aging/client-market-outstanding-aging.component';
import { ClientAgentTransComponent } from './Reports/client-agent-trans/client-agent-trans.component';
import { ReraMindmapComponent } from '../legal/rera-mindmap/rera-mindmap.component';


const routes: Routes = [
  {
    path: '', redirectTo: 'booking', pathMatch: 'full'
  },
  {
    path: 'receipt', component: ReceiptComponent, canActivate: [AuthGuard], data: { roles: ['Receipt_Read_Self'] }
  },
  {
    path: 'receipt/:paymentId', component: ReceiptComponent, canActivate: [AuthGuard], data: { roles: ['Receipt_Read_Self'] }
  },
  {
    path: 'receipt-refund', component: ReceiptRefundComponent, canActivate: [AuthGuard], data: { roles: ['Receipt_Read_Self'] }
  },
  {
    path: 'booking', component: BookingComponent, canActivate: [AuthGuard], data: { roles: ['Booking_Read_Self'] }
  },
  {
    path: 'booking/pending-cancellation', component: BookingPendingCancellationComponent, canActivate: [AuthGuard], data: { roles: ['Booking_Read_Self', 'Allotment_Read_Self'] }
  },
  {
    path: 'booking/cancelled', component: BookingCancelledListComponent, canActivate: [AuthGuard], data: { roles: ['Booking_Read_Self', 'Allotment_Read_Self'] }
  },
  {
    path: 'booking/:bookingId', component: BookingComponent, canActivate: [AuthGuard], data: { roles: ['Booking_Read_Self', 'Receipt_Read_Self'] }
  },
  {
    path: 'booking/:bookingId/receipts', component: ReceiptComponent, canActivate: [AuthGuard], data: { roles: ['Booking_Read_Self', 'Receipt_Read_Self'] }
  },
  {
    path: 'booking/:bookingId/receipts/:paymentId', component: ReceiptComponent, canActivate: [AuthGuard], data: { roles: ['Booking_Read_Self', 'Receipt_Read_Self'] }
  },
  {
    path: 'receipt/:paymentId/booking', component: BookingComponent, canActivate: [AuthGuard], data: { roles: ['Booking_Read_Self', 'Receipt_Read_Self'] }
  },
  {
    path: 'receipt/:paymentId/booking/:bookingId', component: BookingComponent, canActivate: [AuthGuard], data: { roles: ['Booking_Read_Self', 'Receipt_Read_Self'] }
  },
  {
    path: 'client', component: ClientComponent, canActivate: [AuthGuard], data: { roles: ['Client_Read_Self'] }
  },
  {
    path: 'client/:id', component: ClientComponent, canActivate: [AuthGuard], data: { roles: ['Client_Read_Self'] }
  },
  {
    path: 'allotment', component: AllotmentComponent, canActivate: [AuthGuard], data: { roles: ['Allotment_Read_Self'] }
  },
  {
    path: 'allotment/:id', component: AllotmentComponent, canActivate: [AuthGuard], data: { roles: ['Allotment_Read_Self'] }
  },
  {
    path: 'paymentPlan', component: PaymentPlanComponent, canActivate: [AuthGuard], data: { roles: ['Payment_Plan_Read'] }
  },
  {
    path: 'paymentPlan/:id', component: PaymentPlanComponent, canActivate: [AuthGuard], data: { roles: ['Payment_Plan_Read'] }
  },
  {
    path: 'booking/:bookingId/allotment', component: AllotmentComponent, canActivate: [AuthGuard], data: { roles: ['Booking_Read_Self', 'Allotment_Read_Self'] }
  },
  {
    path: 'receipt/:allotmentId/allotment', component: AllotmentComponent, canActivate: [AuthGuard], data: { roles: ['Allotment_Read_Self', 'Receipt_Read_Self'] }
  },
  {
    path: 'dashboard', component: SalesDashboardComponent, canActivate: [AuthGuard], data: { roles: ['View_Dashboard_Sale'] }
  },
  {
    path: 'report/sale-unit-category', component: UnitCategorySaleReportComponent, canActivate: [AuthGuard], data: { roles: ['Sale_Reports'] }
  },
  {
    path: 'report/sale-agent-wise', component: AgentWiseSaleReportComponent, canActivate: [AuthGuard], data: { roles: ['Sale_Reports'] }
  },
  {
    path: 'report/sale-client-wise', component: ClientAgentTransComponent, canActivate: [AuthGuard], data: { roles: ['Sale_Reports'] }
  },
  {
    path: 'report/sale-client-wise-map', component: ReraMindmapComponent, canActivate: [AuthGuard], data: { roles: ['Sale_Reports'] }
  },
  {
    path: 'report/sale-ageing-wise', component: AgeingBucketSaleComponent, canActivate: [AuthGuard], data: { roles: ['Sale_Reports'] }
  },
  {
    path: 'report/outstanding-ageing-agent-wise', component: MarketOutstandingAgeingComponent, canActivate: [AuthGuard], data: { roles: ['Sale_Reports'] }
  }
  ,
  {
    path: 'report/outstanding-ageing-client-wise', component: ClientMarketOutstandingAgeingComponent, canActivate: [AuthGuard], data: { roles: ['Sale_Reports'] }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class SalesRoutingModule { }
